module.exports = __webpack_public_path__ + "static/media/od_hub.445f3f75.png";